/**
 * Shared matchday → i18n label mapping per competition.
 * Each entry: [competitionIds], { matchday: { key, paramKey?: 'matchday' } }
 */
export const MATCHDAY_LABEL_MAP = [
  [
    [19, 132],
    {
      9: { key: 'ko_round_playoffs_first_legs' },
      10: { key: 'ko_round_playoffs_second_legs' },
      11: { key: 'ko_round_of_16_first_legs' },
      12: { key: 'ko_round_of_16_second_legs' },
      13: { key: 'ko_round_quarter_finals_first_legs' },
      14: { key: 'ko_round_quarter_finals_second_legs' },
      15: { key: 'ko_round_semi_finals_first_legs' },
      16: { key: 'ko_round_semi_finals_second_legs' },
      17: { key: 'ko_round_final' }
    }
  ],
  [
    [6395],
    {
      7: { key: 'ko_round_playoffs_first_legs' },
      8: { key: 'ko_round_playoffs_second_legs' },
      9: { key: 'ko_round_of_16_first_legs' },
      10: { key: 'ko_round_of_16_second_legs' },
      11: { key: 'ko_round_quarter_finals_first_legs' },
      12: { key: 'ko_round_quarter_finals_second_legs' },
      13: { key: 'ko_round_semi_finals_first_legs' },
      14: { key: 'ko_round_semi_finals_second_legs' },
      15: { key: 'ko_round_final' }
    }
  ],
  [
    [10700, 36],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_16' },
      5: { key: 'em_ko_round_quarter_finals' },
      6: { key: 'em_ko_round_semi_finals' },
      7: { key: 'ko_round_final' }
    }
  ],
  [
    [999],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_16' },
      5: { key: 'em_ko_round_quarter_finals' },
      6: { key: 'em_ko_round_semi_finals' },
      7: { key: 'ko_round_final' },
      9: { key: 'em_ko_round_of_16' },
      10: { key: 'em_ko_round_quarter_finals' },
      11: { key: 'em_ko_round_semi_finals' },
      12: { key: 'ko_round_final' }
    }
  ],
  [
    [533],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      8: { key: 'ko_round_fifth_place' },
      9: { key: 'em_ko_round_semi_finals' },
      10: { key: 'ko_round_third_place' },
      11: { key: 'ko_round_final' }
    }
  ],
  [
    [1110],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_16' },
      5: { key: 'em_ko_round_quarter_finals' },
      6: { key: 'em_ko_round_semi_finals' },
      7: { key: 'ko_round_third_place_short' },
      8: { key: 'ko_round_final' }
    }
  ],
  [
    [139],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_32' },
      5: { key: 'em_ko_round_of_16' },
      6: { key: 'em_ko_round_quarter_finals' },
      7: { key: 'em_ko_round_semi_finals' },
      8: { key: 'ko_round_third_place_short' },
      9: { key: 'ko_round_final' }
    }
  ],
  [
    [1180],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_quarter_finals' },
      5: { key: 'em_ko_round_semi_finals' },
      6: { key: 'ko_round_final' }
    }
  ],
  [
    [87, 1379],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_quarter_finals' },
      5: { key: 'em_ko_round_semi_finals' },
      6: { key: 'ko_round_third_place' },
      7: { key: 'ko_round_final' }
    }
  ],
  [
    [1235],
    {
      1: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'em_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_16' },
      5: { key: 'em_ko_round_quarter_finals' },
      6: { key: 'em_ko_round_semi_finals' },
      7: { key: 'ko_round_final' }
    }
  ],
  [
    [33],
    {
      1: { key: 'cup_round', paramKey: 'matchday' },
      2: { key: 'cup_round', paramKey: 'matchday' },
      3: { key: 'em_ko_round_of_16' },
      4: { key: 'em_ko_round_quarter_finals' },
      5: { key: 'em_ko_round_semi_finals' },
      6: { key: 'ko_round_final' }
    }
  ],
  [
    [2346],
    {
      1: { key: 'cup_round', paramKey: 'matchday' },
      2: { key: 'cup_round', paramKey: 'matchday' },
      3: { key: 'cup_round', paramKey: 'matchday' },
      4: { key: 'em_ko_round_of_16' },
      5: { key: 'em_ko_round_quarter_finals' },
      6: { key: 'em_ko_round_semi_finals' },
      7: { key: 'ko_round_final' }
    }
  ],
  [
    [4, 5],
    {
      1: { key: 'ko_round_first_leg' },
      2: { key: 'ko_round_second_leg' }
    }
  ],
  [
    [6, 7],
    {
      15: { key: 'ko_round_final' }
    }
  ],
  [
    [188, 189],
    {
      1: { key: 'hockey_olympia_first_round_matchday', paramKey: 'matchday' },
      2: { key: 'hockey_olympia_first_round_matchday', paramKey: 'matchday' },
      3: { key: 'hockey_olympia_first_round_matchday', paramKey: 'matchday' },
      4: { key: 'hockey_olympia_first_round_matchday', paramKey: 'matchday' },
      5: { key: 'hockey_olympia_first_round_matchday', paramKey: 'matchday' },
      6: { key: 'em_ko_round_quarter_finals' },
      7: { key: 'em_ko_round_semi_finals' },
      8: { key: 'ko_round_third_place_short' },
      9: { key: 'ko_round_final' }
    }
  ],  
]

/**
 * @param {number} compId - competition id
 * @param {number} matchday - matchday number
 * @returns {{ key: string, params: object } | null} i18n key and params, or null if no mapping
 */
export function getMatchdayLabel (compId, matchday) {
  if (compId == null || matchday == null || matchday < 1) {
    return null
  }
  for (const [ids, map] of MATCHDAY_LABEL_MAP) {
    if (ids.includes(compId) && map[matchday]) {
      const entry = map[matchday]
      const params = entry.paramKey ? { [entry.paramKey]: matchday } : {}
      return { key: entry.key, params }
    }
  }
  return null
}
